module.exports = __webpack_public_path__ + "static/media/notification.46710f6d.svg";